// auth.js
export const LOGOUT = 'LOGOUT'
export const SAVE_TOKEN = 'SAVE_TOKEN'
export const FETCH_USER = 'FETCH_USER'
export const FETCH_USER_SUCCESS = 'FETCH_USER_SUCCESS'
export const FETCH_USER_FAILURE = 'FETCH_USER_FAILURE'
export const UPDATE_USER = 'UPDATE_USER'

// lang.js
export const SET_LOCALE = 'SET_LOCALE'

//order.js
export const LOAD_VENDORS = 'LOAD_VENDORS'
export const LOAD_PRODUCTS = 'LOAD_PRODUCTS'
export const UPDATE_PAGE = 'UPDATE_PAGE'

//config.js
export const PLAY_SOUND = 'PLAY_SOUND'
